import type { UserState } from './types'

const state = (): UserState => ({
  settings: {
    visited: null,
    lastViewedVersion: '0.0.1',
    viewedSubscriptionExpired: null,
    devicesUpdated: [],
    movedToAnotherDeviceMessages: [],
    showDataGapLine: null
  }
})

export default state
